function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import moment from 'moment';
import clone from 'ramda/src/clone';
import propEq from 'ramda/src/propEq';
import { MetadataCodeTypeIntegerSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { getNameForCode } from 'invision-core/src/components/metadata/codes/codes.helpers';
import { AdditionalPropertyValueType } from 'invision-core/src/components/metadata/codes/codes.additional.properties.constants';
import { saveInventoryStorePickupDetails } from '../../../../../reducers/actions/offering.order.actions';
import { InventoryStorePickupDetailsSelector, IsSendingInventoryToStoreSelector } from '../../../../../reducers/selectors/offering.order.selectors';
import CustomerCareLocaleKeys from '../../../../../locales/keys';
var SendToStorePopupController = /*#__PURE__*/function () {
  function SendToStorePopupController($ngRedux, $anchorScroll, $location) {
    _classCallCheck(this, SendToStorePopupController);
    Object.assign(this, {
      $anchorScroll: $anchorScroll,
      $location: $location,
      $ngRedux: $ngRedux,
      CustomerCareLocaleKeys: CustomerCareLocaleKeys,
      onListUpdated: this.onListUpdated.bind(this),
      onPropertyChanged: this.onPropertyChanged.bind(this)
    });
  }
  return _createClass(SendToStorePopupController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var controllerActions = {
        saveInventoryStorePickupDetails: saveInventoryStorePickupDetails
      };
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          additionalPropValueSelector: MetadataCodeTypeIntegerSelector(CODES.AdditionalPropertyValue, store),
          inventoryStorePickupDetails: InventoryStorePickupDetailsSelector(store),
          isSendingInventoryToStore: IsSendingInventoryToStoreSelector(store)
        };
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.pickupDetailsModel = clone(this.pickupDetails && (this.pickupDetails.id || this.pickupDetails.comments || this.pickupDetails.date) ? this.pickupDetails : this.state.inventoryStorePickupDetails);
      this.cartAdditionalProperties = Array.isArray(this.additionalProperties) ? clone(this.additionalProperties) : [];
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }, {
    key: "submitForm",
    value: function submitForm() {
      if (this.sendToStoreForm.$valid) {
        this.actions.saveInventoryStorePickupDetails(Object.assign({}, this.pickupDetailsModel, {
          date: moment.isMoment(this.pickupDetailsModel.date) ? this.pickupDetailsModel.date.toDate() : this.pickupDetailsModel.date
        }));
        this.onSubmit()();
      } else {
        var old = this.$location.hash();
        this.$location.hash('additionalPropertiesErrorField');
        this.$anchorScroll();
        this.$location.hash(old);
      }
    }
  }, {
    key: "onListUpdated",
    value: function onListUpdated() {
      this.onAdditionalPropertyListUpdated()(this.cartAdditionalProperties);
    }
  }, {
    key: "onPropertyChanged",
    value: function onPropertyChanged(id, newValue) {
      var findType = this.cartAdditionalProperties.find(propEq(id, 'id'));
      switch (findType.type) {
        case AdditionalPropertyValueType.SINGLE_TEXT:
          newValue = [newValue];
          break;
        case AdditionalPropertyValueType.MULTIPLE_TEXT:
          break;
        case AdditionalPropertyValueType.SELECT:
        case AdditionalPropertyValueType.BOOLEAN:
          newValue = newValue ? [getNameForCode(this.state.additionalPropValueSelector, newValue)] : [];
          break;
        default:
          break;
      }
      this.onAdditionalPropertyChanged()(id, newValue);
    }
  }]);
}();
export default {
  bindings: {
    additionalProperties: '<?',
    isLoading: '<?',
    onAdditionalPropertyChanged: '&',
    onAdditionalPropertyListUpdated: '&',
    onClose: '&',
    onSubmit: '&',
    pickupDetails: '<?',
    pickupDetailsConfig: '<'
  },
  controller: SendToStorePopupController,
  template: require('./send.to.store.popup.template.html')
};